import axios from "@/repositories/client";

axios.getCountries = () => {
  return axios.get('athena/v1/config/countries')
    .then(response => {
      return Object.entries(response.data).map(([key, value]) => ({value: key, text: value}));
    });
};

axios.getCurrencies = () => {
  return axios.get('athena/v1/config/currencies')
    .then(response => {
      return Object.entries(response.data).map(([key, value]) => ({value: key, text: value}));
    });
};

axios.getHotelStatuses = () => {
  return axios.get('athena/v1/config/hotel-statuses')
    .then(response => {
      return Object.entries(response.data).map(([key, value]) => ({value: key, text: value}));
    });
};

axios.getHotelFacilities = () => {
  return axios.get('athena/v1/config/facilities')
    .then(response => {
      return Object.entries(response.data).map(([category, facilities]) => {
        return Object.entries(facilities).map(([key, value]) => ({id: key, name: value, category: category}));
      }).flat(1);
    });
};

axios.getInvoiceChannels = () => {
  return axios.get('athena/v1/config/invoice-channels')
    .then(response => {
      return Object.entries(response.data).map(([key, value]) => ({value: key, text: value}));
    });
};

axios.getContractTypes = () => {
  return axios.get('athena/v1/config/contract-types')
    .then(response => {
      return Object.entries(response.data).map(([key, value]) => ({value: key, text: value}));
    });
};

axios.getInvoiceTypes = () => {
  return axios.get('athena/v1/config/invoice-types')
    .then(response => {
      return Object.entries(response.data).map(([key, value]) => ({value: key, text: value}));
    });
};

axios.getTransactionTypes = () => {
  return axios.get('athena/v1/config/transaction-types')
    .then(response => {
      return Object.entries(response.data).map(([key, value]) => ({value: key, text: value}));
    });
};

axios.getTransactionMethods = () => {
  return axios.get('athena/v1/config/transaction-methods')
    .then(response => {
      return Object.entries(response.data).map(([key, value]) => ({value: key, text: value}));
    });
};

axios.getRoomStandards = () => {
  return axios.get('athena/v1/config/room-type-standards')
    .then(response => {
      return Object.entries(response.data).map(([key, value]) => ({id: key, name: value}));
    });
};

axios.getRoomFacilities = () => {
  return axios.get('athena/v1/config/room-facilities')
    .then(response => {
      return Object.entries(response.data).map(([category, facilities]) => {
        return Object.entries(facilities).map(([key, value]) => ({id: key, name: value, category: category}));
      }).flat(1);
    });
};

axios.getRoomSlugs = () => {
  return axios.get('athena/v1/config/room-slugs')
    .then(response => {
      let query = {};
      for (let [type, slugs] of Object.entries(response.data)) {
        query[type] = Object.entries(slugs).map(([key, value]) => ({id: key, name: value}));
      }
      return query
    });
};

axios.getRateTypes = () => {
  return axios.get('athena/v1/config/rate-plan-types')
    .then(response => {
      return Object.entries(response.data).map(([key, value]) => ({value: key, text: value}));
    });
};

axios.getMeals = () => {
  return axios.get('athena/v1/config/meal-types')
    .then(response => {
      return Object.entries(response.data).map(([key, value]) => ({id: key, name: value}));
    });
};

axios.getCards = () => {
  return axios.get('athena/v1/config/accepted-cards')
    .then(response => {
      return Object.entries(response.data).map(([key, value]) => ({value: key, text: value}));
    });
};

axios.getCancellationPolicyFormula = () => {
  return axios.get('athena/v1/config/cancellation-policy-formula')
    .then(response => ({
        'penalty_types': Object.entries(response.data.penalty_types).map(([key, value]) => ({value: key, text: value})),
        'interval_types': Object.entries(response.data.interval_types).map(([key, value]) => ({value: key, text: value}))
      })
    );
};

axios.getPaymentPolicyFormula = () => {
  return axios.get('athena/v1/config/payment-policy-formula')
    .then(response => ({
        'penalty_types': Object.entries(response.data.penalty_types).map(([key, value]) => ({value: key, text: value})),
        'interval_types': Object.entries(response.data.interval_types).map(([key, value]) => ({value: key, text: value}))
      })
    );
};

axios.getPermissions= () => {
  return axios.get('athena/v1/config/permissions')
    .then(response => {
      return Object.entries(response.data).map(([key, value]) => ({value: value, text: value}));
    });
};

export default axios;